module.exports = __webpack_public_path__ + "img/image 5.3aba6adc.png";